import state from "@/store/modules/my-task/state";
import actions from "@/store/modules/my-task/actions";
import mutations from "@/store/modules/my-task/mutations";
import getters from "@/store/modules/my-task/getters";

export default {
  state,
  actions,
  mutations,
  getters
}